import { Link } from "react-router-dom";
import AuthPage from "../../components/layout/authPage";
import { BoxContainer, Col, HeroBanner, IconArea, IconAreaImg, List, ListItem, MainContainer, Row, SubTitle, Text, Title, VImage } from "../../style/base.style";
import { circDouble, circleBg, clockIcon, doctorBanner2, doctorBanner3, doctorIcon, faq_img, faq_img2, footerBg1, footerBg2, hexagenBg, phoneIcon, smiling_icon, stepsBg } from "../../constants/images";
import { useDictionary } from "../../contexts/dictionary";
import "aos/dist/aos.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Colors } from "../../style/colors";
import { FAQComponent } from "../../components/faq";
import AOS from "aos";
import "aos/dist/aos.css";
import React, { use, useEffect, useState } from "react";



import { TitleProgressBar } from "../../components/common/titlesProgressBar";
import { routesMap } from "../../constants/routes";
import { useDeviceType } from "../../contexts/DeviceContext";


const steps = [
    {
        label:"choose_a_plan",
        link: routesMap.checkoutChoosePlan.to,
    },
    {
        label:"register",
        link: routesMap.checkoutReg.to,
    },
    {
        label:"update_your_info",
        link: routesMap.checkoutAddtionalInfo.to,
    },
    {
        label:"add_family_members",
        link: routesMap.checkoutFamily.to,
    },
    {
        label:"payment",
        link: routesMap.checkoutPayment.to,
    }

]


interface CheckoutLayoutProps {
    page:"choose_a_plan" | "register" | "update_your_info" | "add_family_members" | "payment";
    children?: React.ReactNode;
}

export const CheckoutLayout:React.FC<CheckoutLayoutProps> = ({page,children}) => {
    
    const {isMobile} = useDeviceType()
    
    AOS.init();
      useEffect(() => {
        AOS.init({
          duration: 1000,
        });
      }, []);
      const handleScroll = () => {
        AOS.refresh();
      };
      useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
      }, []);


    return (
        <AuthPage>
          <MainContainer $isMobile={isMobile} className="main-cont">
            <BoxContainer className="box-cont">
              <TitleProgressBar
                steps={steps}
                currentStep={steps.findIndex((p)=> p.label === page)}
              />
            </BoxContainer>
            {
                children
            }
       </MainContainer>
       

  
          
          
        </AuthPage>
    );

}